export function getUnits() {
    return [
        'szt', 
        'godz',
        'dni',
        'mc',
        'km',
        'm2',
        'kg',
        'inna'
    ];
}